import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/store";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from "react-router-dom";
import LoginScreen from "./screens/login-screen/LoginScreen";
import PrivateRoute from "./components/PrivateRoute";
import DashboardScreen from "./screens/dashboard-screen/DashboardScreen";
import ForgetPasswordScreen from "./screens/forget-password-screen/ForgetPasswordScreen";
import SetNewPasswordScreen from "./screens/set-new-password/setNewPasswordScreen";
import ReportsScreen from "./screens/reports-screen/ReportsScreen";
import SettingsScreen from "./screens/settings-screen/SettingsScreen";
import CreateNewAccount from "./screens/create-account-screen/CreateNewAccount";
import FacilityManagementScreen from "./screens/facility-management-screen/FacilityManagementScreen";
import FacilityDetailsScreen from "./screens/facility-management-screen/facility-details/FacilityDetailsScreen";
import NoRouteFoundScreen from "./screens/no-route-found-screen/NoRouteFoundScreen";
import UserProfilePage from "./screens/facility-management-screen/facility-details/UserProfilePage";
import InventoryScreen from "./screens/inventory-screen/InventoryScreen";
import OrdersScreen from "./screens/orders-screen/OrdersScreen";
import TemplateScreen from "./screens/settings-screen/communications-screens/TemplateScreen";
import CommunicationRuleScreen from "./screens/settings-screen/communications-screens/CommunicationRuleScreen";
import RolesAndResponsibility from "./screens/settings-screen/account-management-screens/roles-and-responsibility/RolesAndResponsibility";
import RolesScreen from "./screens/settings-screen/account-management-screens/RolesScreen";
import DataImport from "./screens/settings-screen/master-screens/DataImport";
import CodeScreen from "./screens/settings-screen/master-screens/CodeScreen";
import ContactDirectory from "./screens/contact-directory/ContactDirectory";
import DrugCatalogue from "./screens/settings-screen/master-screens/DrugCatalogue";
import OrderStatusScreen from "./screens/settings-screen/master-screens/OrderStatusScreen";
import OrderTypesScreen from "./screens/settings-screen/master-screens/OrderTypesScreen";
import TaskTypeScreen from "./screens/settings-screen/master-screens/TaskTypeScreen";
import MasterDataScreen from "./screens/settings-screen/master-screens/MasterDataScreen";
import AdminUserScreen from "./screens/settings-screen/account-management-screens/AdminUserScreen";
import UsersScreen from "./screens/settings-screen/account-management-screens/roles-and-responsibility/users-screen/UsersScreen";
import NotificationScreen from "./screens/notification-screen/NotificationScreen";
import ChatBox from "./screens/messaging-screen/ChatBox";
import SuccessPage from "./screens/set-new-password/SuccesPage";
import NavigateEmailSuccessPage from "./screens/set-new-password/NavigateEmailSuccessPage";
import TasksScreen from "./screens/tasks-screen/TasksScreen";
import DocumentsScreen from "./screens/documents-screen/DocumentsScreen";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      {/* OUR PUBLIC ROUTES COME HERE  */}
      <Route index element={<Navigate to="/login" />} />
      <Route index={true} path="/login" element={<LoginScreen />} />
      <Route
        index={true}
        path="/create-new-account"
        element={<CreateNewAccount />}
      />
      <Route
        index={true}
        path="/forget-password"
        element={<ForgetPasswordScreen />}
      />
      <Route
        index={true}
        path="/set-new-password"
        element={<SetNewPasswordScreen />}
      />
      <Route path="/success-screen" element={<SuccessPage />} />
      <Route path="/email-check" element={<NavigateEmailSuccessPage />} />
      {/* OUR PRIVATE ROUTES HERE */}
      <Route path="" element={<PrivateRoute />}>
        <Route path="/dashboard" element={<DashboardScreen />} />
        <Route path="/reports" element={<ReportsScreen />} />
        <Route
          path="/facility-management"
          element={<FacilityManagementScreen />}
        />
        <Route
          path="/facility-management/:facilityId"
          element={<FacilityDetailsScreen />}
        />
        <Route path="/contact-directory" element={<ContactDirectory />} />
        <Route path="/tasks" element={<TasksScreen />} />
        <Route path="/settings" element={<SettingsScreen />} />
        <Route path="/inventory-management" element={<InventoryScreen />} />
        <Route path="/orders" element={<OrdersScreen />} />
        <Route path="/documents" element={<DocumentsScreen />} />

        <Route
          path="/settings/account-management/user-profile"
          element={<UserProfilePage />}
        />
        <Route
          path="/settings/account-management/:selectedUser"
          element={<AdminUserScreen />}
        />
        <Route
          path="/settings/account-management/user/:User"
          element={<UsersScreen />}
        />
        <Route
          path="/settings/account-management/roles"
          element={<RolesScreen />}
        />
        <Route
          path="/settings/account-management/roles-and-responsibility"
          element={<RolesAndResponsibility />}
        />
        <Route
          path="/settings/communications/:selectedTemplate"
          element={<TemplateScreen />}
        />
        <Route
          path="/settings/communications/communication-rule"
          element={<CommunicationRuleScreen />}
        />
        <Route path="/settings/master/data-import" element={<DataImport />} />
        <Route
          path="/settings/master/drug-catalogue"
          element={<DrugCatalogue />}
        />
        <Route
          path="/settings/master/order-status"
          element={<OrderStatusScreen />}
        />
        <Route
          path="/settings/master/order-types"
          element={<OrderTypesScreen />}
        />
        <Route
          path="/settings/master/task-type"
          element={<TaskTypeScreen />}
        />
        <Route
          path="/settings/master/incident-location"
          element={
            <MasterDataScreen
              type="incident_location"
              title="Incident Location"
              nameLabel="Incident Location Name"
              addButtonLabel="Add Incident Location"
              dialogTitle="Add Incident Location"
            />
          }
        />
        <Route
          path="/settings/master/primary-treating-clinician"
          element={
            <MasterDataScreen
              type="primary_treating_clinician"
              title="Primary Treating Clinician"
              nameLabel="Clinician Name"
              addButtonLabel="Add Clinician"
              dialogTitle="Add Primary Treating Clinician"
            />
          }
        />
        <Route
          path="/settings/master/unit-designation"
          element={
            <MasterDataScreen
              type="unit_designation"
              title="Unit Designation"
              nameLabel="Unit Name"
              addButtonLabel="Add Unit"
              dialogTitle="Add Unit Designation"
            />
          }
        />
        <Route path="/notifications" element={<NotificationScreen />} />
        <Route path="/messaging" element={<ChatBox />} />

        <Route path="/settings/master/:selectedCode" element={<CodeScreen />} />
      </Route>
      <Route path="*" element={<NoRouteFoundScreen />} />
    </Route>
  )
);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
